

















import { Component, Prop, Mixins } from 'vue-property-decorator'

import { OrderMixin } from '@/mixins'
import { OrderDelivery } from '../interfaces'

@Component
export default class extends Mixins(OrderMixin) {
  @Prop(Object) readonly orderDelivery!: OrderDelivery
  @Prop(String) readonly orderStatus!: string
  @Prop(String) readonly thumbnailUrl!: string

  get statusTextClass () {
    const color = this.getTitleAndColor(this.orderStatus, this.orderDelivery.status, this.orderDelivery.orderItems[0].status,
      this.deliveryIsDelayed(this.orderDelivery)).color
    return {
      'text--primary': color === 'chili',
      'text--secondary': color === 'mainBlue',
      'text--warm-grey': color === 'dark60'
    }
  }
}
